import React from 'react';
import '../styles/components/_loading.scss';

const Loading: React.FC = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner-components"></div>
      <h2 className="loading-title-components">Carregando...</h2>
      <p className="loading-text-components">Por favor aguarde um instante.</p>
    </div>
  );
};

export default Loading;
